import type { Middleware } from 'redux';
import { captureException } from '../../../tracker/raven';
import { commonLogger } from '../../../utils/logger/loggerFactory';

function toError(error: Error | string | object | null | undefined): Error {
    if (error instanceof Error) {
        return error;
    }
    return new Error(typeof error === 'string' ? error : 'Unknown middleware error');
}

const errorsIntercepter: Middleware = () => next => action => {
    try {
        return next(action);
    } catch (error) {
        const actualError = toError(error);
        captureException(actualError);
        commonLogger.error(actualError.message, actualError);
        return undefined;
    }
};

export default errorsIntercepter;
